'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Freezer = function (_React$Component) {
    _inherits(Freezer, _React$Component);

    function Freezer() {
        _classCallCheck(this, Freezer);

        return _possibleConstructorReturn(this, (Freezer.__proto__ || Object.getPrototypeOf(Freezer)).apply(this, arguments));
    }

    _createClass(Freezer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M6.69 14.77c.267 0 .482-.215.482-.48v-3.44c0-.265-.215-.48-.48-.48s-.482.215-.482.48v3.44c0 .265.215.48.48.48zM9.006 20.184l.528.17-.346.29c-.205.17-.232.473-.062.677.095.115.232.174.37.174.11 0 .22-.037.31-.11l.81-.677 1.55.503-.956 1.318-1.054-.07c-.26-.014-.494.184-.512.45s.184.494.45.512l.447.03-.325.448c-.156.215-.11.516.106.672.087.062.185.092.284.092.15 0 .296-.07.39-.198l.326-.45.167.418c.075.188.256.303.447.303.06 0 .12-.01.18-.034.246-.098.366-.378.268-.625l-.39-.98.957-1.32.957 1.32-.39.98c-.1.248.02.528.268.626.058.025.118.035.178.035.19 0 .372-.115.447-.303l.166-.417.326.45c.094.13.24.197.39.197.098 0 .197-.03.283-.092.215-.156.263-.457.106-.672l-.325-.448.45-.03c.264-.017.465-.247.448-.512s-.237-.458-.512-.45l-1.053.07-.957-1.318 1.55-.503.812.675c.09.075.2.11.308.11.138 0 .275-.058.37-.172.17-.205.143-.508-.06-.678l-.346-.287.527-.17c.254-.083.392-.355.31-.607s-.354-.39-.606-.31l-.528.172.11-.436c.066-.257-.09-.52-.347-.585-.26-.065-.52.09-.586.347l-.26 1.024-1.55.504v-1.63l.894-.564c.225-.142.292-.44.15-.664s-.44-.29-.664-.15l-.38.24v-.555c0-.265-.215-.48-.48-.48s-.482.215-.482.48v.556l-.38-.24c-.225-.14-.522-.074-.664.15s-.075.522.15.664l.894.565v1.63l-1.55-.504-.26-1.024c-.065-.257-.327-.41-.584-.348-.257.065-.413.327-.348.585l.11.436-.528-.172c-.252-.082-.524.056-.606.31-.086.252.053.523.306.605z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M20.247 0h-14.9c-.898 0-1.63.73-1.63 1.628v28.745c0 .897.732 1.627 1.63 1.627h14.9c.897 0 1.628-.73 1.628-1.627V1.628C21.875.73 21.145 0 20.247 0zM4.68 1.628c0-.367.3-.666.666-.666h14.9c.368 0 .666.298.666.666v5.534H4.68V1.628zm15.567 29.41h-14.9c-.368 0-.666-.3-.666-.666V8.124h16.233v22.25c0 .365-.3.663-.666.663z' })
            );
        }
    }]);

    return Freezer;
}(_react2.default.Component);

Freezer.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Freezer;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/freezer.js
// module id = 1101
// module chunks = 0